import React from "react";
import { Stack, Text } from "@fluentui/react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ICatalystCustomerSentiment } from "../../../../interfaces/Catalyst.interfaces";

export interface CatalystCustomerSentimentTableProps {
  data?: ICatalystCustomerSentiment[];
  isLoading?: boolean;
}

export const CatalystCustomerSentimentTable: React.FC<CatalystCustomerSentimentTableProps> = ({
  data,
  isLoading = false,
}) => {
  const rows = (data || []).map((item, index) => ({
    id: index,
    customerName: item.customerName ?? "-",
    sentimentProvidedBy: item.sentimentProvidedBy ?? "-",
    sentimentScore: item.sentimentScore ?? "-",
    sentimentDate: item.sentimentDate
      ? new Date(item.sentimentDate).toLocaleDateString()
      : "-",
    product: item.product ?? "-",
    selfReportedTrend: item.selfReportedTrend ?? "-",
    role: item.role ?? "-",
    customerContact: item.customerContact ?? "-",
    csatOwner: item.csatOwner ?? "-",
  }));

  const columns: GridColDef[] = [
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1.45,
      minWidth: 220,
    },
    {
      field: "sentimentProvidedBy",
      headerName: "Sentiment Provided By",
      flex: 0.75,
      minWidth: 115,
    },
    {
      field: "sentimentScore",
      headerName: "Sentiment Score",
      width: 98,
      minWidth: 88,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "sentimentDate",
      headerName: "Sentiment Date",
      width: 104,
      minWidth: 94,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "product",
      headerName: "Product",
      width: 92,
      minWidth: 82,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "selfReportedTrend",
      headerName: "Self Reported Trend",
      width: 116,
      minWidth: 102,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "role",
      headerName: "Role",
      width: 88,
      minWidth: 72,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "customerContact",
      headerName: "Customer Contact",
      flex: 0.75,
      minWidth: 105,
    },
    {
      field: "csatOwner",
      headerName: "CSAT Owner",
      flex: 0.95,
      minWidth: 125,
    },
  ];

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { flex: 1 } }}>
      <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
        Customer Sentiment
      </Text>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        autoHeight
        rowHeight={36}
        columnHeaderHeight={56}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10]}
        initialState={{
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton" as any,
            noRowsVariant: "skeleton" as any,
          },
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            paddingLeft: 2,
            paddingRight: 2,
          },
          "& .MuiDataGrid-row:hover": { backgroundColor: "#F3F2F1" },
        }}
      />
    </Stack>
  );
};
